// extracted by mini-css-extract-plugin
module.exports = {"perkIconWrapper":"styles_perkIconWrapper__tq6Dn"};